module.exports = __webpack_public_path__ + "img/lan_tour_00_m.94085727.jpg";